<p-card [header]="pageTitle">
  <router-outlet></router-outlet>
</p-card>
